import React, { useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
  Toolbar,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import TrainingModal from "../components/TrainingModal";
import { Link } from "react-router-dom";
import Navigation from "../components/Navigation";

const HeroSection = () => (
  <Box
    sx={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      position: "relative",
      overflow: "hidden",
      pt: 8,
    }}
  >
    {/* Background Video */}
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 0,
      }}
    >
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          opacity: "0.3",
        }}
      >
        <source src="/Kalisunasset1.mp4" type="video/mp4" />
      </video>
      {/* Gradient Overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",

          zIndex: 1,
        }}
      />
    </Box>

    {/* Content */}
    <Container
      maxWidth="lg"
      sx={{
        position: "relative",
        zIndex: 2,
      }}
    >
      <Typography
        variant="h5"
        align="center"
        // color="text.secondary"
        gutterBottom
        sx={{
          textShadow: "0 2px 4px rgba(0,0,0,0.3)",
        }}
      >
        Ready to Boost Your Life Insurance Premium Without Endless Dialing?
      </Typography>
      <Typography
        variant="h1"
        align="center"
        gutterBottom
        color="#4e63cb"
        sx={{
          my: 4,
          fontWeight: "bold",
          textShadow: "0 2px 4px rgba(0,0,0,0.3)",
        }}
      >
        ACCESS HIGH-CONVERTING
        <br />
        AI-QUALIFIED INSURANCE PROSPECTS
        <br />
        AT UNBEATABLE VALUE
      </Typography>
    </Container>
  </Box>
);
const DemoSection = () => {
  const [open, setOpen] = useState(false);
  return (
    <Box
      sx={{
        py: 12,
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "radial-gradient(circle at center, rgba(124, 77, 255, 0.2) 0%, rgba(26, 35, 126, 0) 70%)",
          pointerEvents: "none",
        },
      }}
    >
      <Container maxWidth="lg">
        {/* Demo Header */}
        <Box sx={{ textAlign: "center", mb: 8 }}>
          <Typography
            variant="h5"
            component="div"
            sx={{
              mb: 3,
              color: "#fff",
              background:
                "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0) 100%)",
              py: 2,
              fontWeight: 500,
            }}
          >
            Learn how to use AI to beat the traditional way of lead
            generation!
          </Typography>
          <Typography
            variant="h2"
            sx={{
              fontWeight: 700,
              background: "linear-gradient(90deg, #fff 0%, #e0e0e0 100%)",
              backgroundClip: "text",
              textFillColor: "transparent",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              cursor: "pointer",
              mb: 4,
            }}
            onClick={() => setOpen(true)}
          >
            FREE AI LEAD GEN DEMO
          </Typography>
        </Box>

        {/* Demo Content */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: 4, md: 6 },
            mb: 8,
            alignItems: "center",
          }}
        >
          {/* Left Column - AI Powered Leads */}

          {/* Right Column - Demo Preview */}
          <Card
            elevation={12}
            sx={{
              flex: { md: 2 },
              background: "rgba(0,0,0,0.4)",
              borderRadius: 3,
              overflow: "hidden",
              border: "1px solid rgba(255,255,255,0.1)",
            }}
          >
            <CardContent sx={{ p: "0 !important" }}>
              {/* <Box
                onClick={() => setOpen(true)}
                component="img"
                src="/section2.webp"
                alt="Demo Preview"
                sx={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.02)",
                  },
                }}
              /> */}
               <video
                controls
                autoPlay
                loop
                muted
                playsInline
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              >
                <source src="/KaliSun_Revision_Video_no_watermark.mp4" type="video/mp4" />
              </video>

            </CardContent>
          </Card>
        </Box>

        {/* CTA Button */}
        <Box
          sx={{
            textAlign: "center",
            position: "relative",
            "&::before": {
              content: '""',
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "200px",
              height: "200px",
              background:
                "radial-gradient(circle, rgba(124,77,255,0.2) 0%, rgba(124,77,255,0) 70%)",
              zIndex: 0,
            },
          }}
        >
          <Button
            variant="contained"
            size="large"
            onClick={() => setOpen(true)}
            endIcon={<ArrowForwardIcon />}
            sx={{
              px: 6,
              py: 2.5,
              fontSize: "1.2rem",
              fontWeight: 600,
              borderRadius: 3,
              background: "linear-gradient(45deg, #7c4dff 30%, #448aff 90%)",
              boxShadow: "0 3px 20px rgba(124,77,255,0.3)",
              position: "relative",
              zIndex: 1,
              "&:hover": {
                background: "linear-gradient(45deg, #673ab7 30%, #3f51b5 90%)",
                transform: "translateY(-2px)",
                boxShadow: "0 6px 25px rgba(124,77,255,0.4)",
              },
              transition: "all 0.3s ease-in-out",
            }}
          >
            Get Training Now
          </Button>

          <TrainingModal open={open} onClose={() => setOpen(false)} />
        </Box>
      </Container>
    </Box>
  );
};

const Footer = () => (
  <Box
    component="footer"
    sx={{
      py: 6,
      textAlign: "center",
    }}
  >
    <Typography variant="h6" gutterBottom>
      KALISUNMARKETING.COM
    </Typography>
    <Typography variant="body2" color="text.secondary" gutterBottom>
      <Link style={{ textDecoration: 'none', color: '#0f8f0f' }} target="_blank" to="https://www.trustpilot.com/review/kalisunmarketing.com">Check Us Out On ★ Trustpilot</Link>
      {/* <a href="" target="_blank">  </a> */}
    </Typography>
    <Typography variant="caption" color="text.secondary">
      Copyright © kalisunmarketing.com 2024. All Rights Reserved.
      <br />
      Results shown are not typical and required hard work & dedication.
    </Typography>
  </Box>
);

const Home = () => {
  return (
    <Box
      sx={{
        bgcolor: "background.default",
        color: "text.primary",
        minHeight: "100vh",
      }}
    >
      <Navigation />
      {/* <HeroSection /> */}
      <DemoSection />
      <Footer />
    </Box>
  );
};

export default Home;
